// src/components/common/Button.jsx
const Button = ({ variant = "primary", className = "", children, ...props }) => {
  const base = "flex items-center justify-center gap-2 font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-400 disabled:opacity-50 disabled:cursor-not-allowed";

  const getVariantClasses = () => {
    switch (variant) {
      // Yellow/brand primary
      case "primary":
        return "px-4 py-2 bg-primary-400 hover:bg-primary-600 text-black-900 border-2 border-primary-400 hover:border-primary-600 rounded text-lg";

      // Black filled
      case "dark":
        return "px-4 py-2 bg-black-600 hover:bg-black-900 text-white border-2 border-black-600 hover:border-black-900 rounded-lg text-lg";

      // Ghost / outline black
      case "ghost":
        return "px-4 py-2 bg-black-0 hover:bg-black-20 text-black-800 border-2 border-black-600 rounded-lg text-lg";

      // Icon only (editor, image buttons)
      case "icon":
        return "w-10 h-10 sm:w-11 sm:h-11 border border-black-600 rounded bg-black-0 hover:bg-black-20 focus:bg-black-40";

      // Icon + visible label — same height as `icon`, so they align in a toolbar
      case "iconText":
        return "h-10 sm:h-11 px-3 border border-black-600 rounded bg-black-0 hover:bg-black-20 focus:bg-black-40 text-sm text-black-800";

      // Icon only, compact — inline rows where 40px is too tall
      case "iconSm":
        return "w-9 h-9 border border-black-600 rounded bg-black-0 hover:bg-black-20 focus:bg-black-40";

      // Icon + label, pressed — toolbar toggles in their ON state
      case "iconTextActive":
        return "h-10 sm:h-11 px-3 border border-black-800 rounded bg-black-800 hover:bg-black-600 focus:bg-black-600 text-sm text-black-0 [&_img]:invert";

      // LinkedIn status (connected/not connected)
      case "social":
        return "px-4 py-2 bg-black-20 hover:bg-black-40 text-black-700 border-2 border-black-800 rounded-md text-lg font-medium space-x-2";

      // LinkedIn connect button
      case "linkedin":
        return "px-4 py-2.5 bg-[#0A66C2] hover:bg-[#004182] text-white border-2 border-[#0A66C2] hover:border-[#004182] rounded text-lg";

      case "disconnect": 
        return "px-4 py-2.5 bg-black-0 hover:bg-red-50 text-black-800 border-2 border-red-600 rounded text-lg font-medium focus:ring-red-400";

      // Language selector (inactive)
      case "language":
        return "h-[42px] px-4 bg-white text-sm sm:text-lg border-2 border-gray-300 hover:border-primary-200 rounded-lg";

      // Language selector (active)
      case "languageActive":
        return "h-[42px] px-4 bg-primary-200 text-sm sm:text-lg border-2 border-primary-200 rounded-lg";

      // Sidebar minimized
      case "sidebarIcon":
        return "p-2 bg-black-0 hover:bg-primary-200 text-black-800 border border-black-600 hover:!border-primary-300 rounded-lg";

      // Sidebar expanded
      case "sidebarExpanded":
        return "px-4 py-2 bg-black-0 hover:bg-primary-200 text-black-800 border border-black-600 hover:!border-primary-300 rounded-lg !justify-start font-medium";

      // Emoji button wrapper
      case "emojiButton":
        return "flex border border-black-600 rounded";

      // Text link: underlined, no box (secondary actions like Reset)
      case "link":
        return "px-1 py-1 bg-transparent text-black-800 hover:text-black-900 underline underline-offset-2 text-sm rounded";

      default:
        return "";
    }
  };

  return (
    <button className={`${base} ${getVariantClasses()} ${className}`} {...props}>
      {children}
    </button>
  );
};

export default Button;